import green from '@material-ui/core/colors/green';
import red from '@material-ui/core/colors/red';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { Box } from 'home/useBoxes';
import { BoxStatus } from 'home/useSubBoxStatuses';
import { Unlock_Request_Type_Enum } from 'generated/graphql';
import yellow from '@material-ui/core/colors/yellow';
import MBox from '@material-ui/core/Box';
import { Label } from 'labels';

interface Props {
  box: Box;
  status: BoxStatus;
}

const useStyles = makeStyles((theme: Theme) => ({
  unlocked: {
    color: ({ status }: Props) => (status.isUnlocked ? red[700] : green[700]),
  },
  battery: {
    color: ({ status }: Props) => (status.isBattery ? red[700] : green[700]),
  },
  open: {
    color: ({ status }: Props) => (status.isOpen ? red[700] : green[700]),
  },
  request: { color: yellow[800] },
  online: {
    color: ({ status }: Props) =>
      status.isOnline ? theme.palette.success.dark : theme.palette.grey[600],
  },
}));

const BoxInfoWindow = ({ box, status }: Props) => {
  const classes = useStyles({ box, status });

  const boxStatusInfo = (
    <>
      {status.requestStatus === Unlock_Request_Type_Enum.Request ? (
        <Typography variant="body1" className={classes.request}>
          鍵解錠送信中
        </Typography>
      ) : null}

      <Typography variant="body1" className={classes.unlocked}>
        {status.isUnlocked === null
          ? null
          : status.isUnlocked
          ? Label.KeyOpen
          : Label.KeyClose}
      </Typography>

      <Typography variant="body1" className={classes.open}>
        {status.isOpen === null
          ? null
          : status.isOpen
          ? Label.DoorOpen
          : Label.DoorClose}
      </Typography>

      {status.isBattery ? (
        <Typography variant="body1" className={classes.battery}>
          {Label.BackupBattery + '使用中'}
        </Typography>
      ) : null}
    </>
  );

  const postcode = box.postcode
    ? `${box.postcode.slice(0, 3)}-${box.postcode.slice(3)}`
    : '';

  return (
    <MBox>
      <MBox display="grid" gridTemplateColumns="1fr 1fr">
        <Typography variant="subtitle1">名前: {box.name}</Typography>
        <Typography variant="subtitle1">IMEI: {box.imei}</Typography>
      </MBox>
      <MBox
        paddingTop={1}
        paddingBottom={1}
        display="grid"
        gridTemplateColumns="auto 1fr"
        gridColumnGap="10px"
      >
        {box.prefectureName ? (
          <Typography variant="body2">{box.prefectureName}</Typography>
        ) : null}
        <Typography variant="body2">{postcode}</Typography>
        <MBox gridColumn="span 2">
          <Typography variant="body2">{box.address}</Typography>
        </MBox>
      </MBox>
      <MBox
        paddingTop={1}
        paddingBottom={1}
        display="grid"
        gridTemplateColumns="1fr 1fr"
      >
        <Typography variant="body2">{`緯度: ${box.coords.lat()}`}</Typography>
        <Typography variant="body2">{`経度: ${box.coords.lng()}`}</Typography>
      </MBox>

      {boxStatusInfo}
      <MBox paddingTop={1} display="grid" gridTemplateColumns="auto 1fr">
        <Typography variant="body2" className={classes.online}>
          {status.isOnline ? 'オンライン' : 'オフライン'}
        </Typography>

        <Typography variant="body2" align="right">
          最新更新: {status?.updatedAtText ?? 'データがない'}
        </Typography>
      </MBox>
    </MBox>
  );
};

export default BoxInfoWindow;
